import apifetch from "./apifetch"

/**
 * 
 * @description Utility function um fetch-Requests abbrechbar zu machen.
 * 
 * @param {*} request 
 * @param {*} opts 
 * @returns 
 */

export default function abortableFetch(request, opts) {
  const controller = new AbortController();
  const signal = controller.signal;
  /** @type {ReadableStreamDefaultReader<Uint8Array>} */
  let reader = null;
  let headers = null;
  let canceled = false;
  let promise = apifetch(request, { ...opts, signal })
  //   .then((rb) => {
  //   reader = rb.body.getReader();
  //   headers = rb.headers
  //   console.log("start Consume");

    /**
     * Der folgende Teil ist leider nötig, um einen bereits im konsumierenden Status befindlichen Request zu canceln. 
     * Warum ist das nötig? fetch() ist über ein AbortSignal cancelbar, dieses Signal wirkt aber nur solange der Server keine Antwort geschickt hat. Hat der Server schon mit seiner Antwort angefangen können wir den Request nun nicht mehr über das Signal canceln. 
     * Weitere Möglichkeit ReadableStream hat eine cancel Methode und das body-Property eines Response-Objekts ist rein zufällig ein ReadableStream. Problem ist leider, dass man nicht einfach auf dem body vom Response-Objekt cancel aufrufen kann, da sobald man einen Reader von einem ReadableStream hat, dieser gelockt ist. Nutzt man text(), json(), .etc auf einem Response-Objekt wird ein reader auf dem Response.body-ReadableStream erzeugt und somit dieser gelockt. Heißt man kann ihn von außen nicht canceln. Um zumindest Clientseitig die Auswertung zu unterbinden kann man nun einen eigenen ReadableStream definieren, den man Canceln kann.
     * kommt einem alles wie mit der linken Hand am rechten Ohr kratzen vor ... 
    */
  //   return new ReadableStream({
  //     start(controller) {
  //       // The following function handles each data chunk
  //       function push() {
  //         // "done" is a Boolean and value a "Uint8Array"
  //         reader.read().then(({ done, value }) => {
  //           if (canceled)
  //           throw new Error("canceled")
  //           // If there is no more data to read
  //           if (done) {
  //             // console.log('done', done);
  //             controller.close();
  //             return;
  //           }
  //           // Get the data and send it to the browser via the controller
  //           controller.enqueue(value);
  //           // Check chunks by logging to the console
  //           // console.log(done, value);
  //           push();
  //         });
  //       }

  //       push();
  //     },
  //   });
  // })
  // .then((stream) =>
  //   // Respond with our stream
  //   new Response(stream, { headers })
  // )

  return {
    abort: () => {
      controller.abort();
      // if (reader) {
        // reader.cancel()
        // canceled = true;
          // .then(() => console.log("canceled"));
      // }
    },
    ready: promise
  };

}